import * as React from 'react';
import { IntlProps } from 'ha/i18n';
import { WithRouterProps } from 'react-router';
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';
import Button, { ButtonProps } from '@material-ui/core/Button';
import AddAlertIcon from '@material-ui/icons/AddAlert';

import units from 'ha/theme/units';
import Track from 'ha/components/track/SmartTrack';
import NoSSR from 'ha/components/NoSSR';

export interface Props {
  isDisabled: boolean;
  hasAlert: boolean;
  isAuthenticated: boolean;
  isMobile: boolean;
  color?: ButtonProps['color'];
  variant?: ButtonProps['variant'];
  getDynamicData: () => object;
  onClick?: (options?: object) => void;
}

const styles = (t: Theme) =>
  createStyles({
    icon: {
      marginRight: t.spacing.unit,
      fontSize: units.rem(1.2),
    },
  });

export class SearchAlertButton extends React.Component<
  Props & IntlProps & WithRouterProps & WithStyles<typeof styles>
> {
  handleClick = () => {
    const {
      onClick,
      intl: { T },
    } = this.props;

    if (onClick) {
      onClick({
        title: T('search_alert_create_confirmation_title'),
        description: T('search_alert_create_confirmation_text'),
        hideBenefits: true,
        hideLogo: true,
      });
    }
  };

  render() {
    const {
      classes,
      isMobile,
      isDisabled,
      hasAlert,
      getDynamicData,
      intl: { T },
      color = 'secondary',
      variant = 'outlined',
    } = this.props;

    return (
      <NoSSR>
        <Track
          name="Clicked create search alert"
          type="button"
          getDynamicData={getDynamicData}
        >
          <Button
            color={color}
            variant={variant}
            onClick={this.handleClick}
            disabled={isDisabled}
            size={isMobile ? 'small' : undefined}
            data-test-locator="Search Alert Button"
          >
            <AddAlertIcon className={classes.icon} />
            {hasAlert
              ? T('search_alert_update_button')
              : T('search_alert_create_button')}
          </Button>
        </Track>
      </NoSSR>
    );
  }
}

export default withStyles(styles)(SearchAlertButton);
